<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">اطلاعات پیامک</h5>
      <br />
      <br />

      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">کلید واژه</label>
          <input [(ngModel)]="Filter_Key" name="Filter_Key" type="text"
            class="form-control" placeholder="برای جستجوی ، اینجا تایپ کنید ...">
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">نوع پیامک</label>
          <select class="custom-select" [(ngModel)]="Filter_Title" name="Filter_Title">
            <option value="0">همه موارد</option>
            <option *ngFor="let item of DataList_Title" [value]="item.id">{{item.title}}</option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-6">
          <button *ngIf="!Procssing" type="button" (click)="ReadData_SMS()" class="btn btn-info"
            style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>
      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>نوع پیامک</th>
              <th>متن پیامک</th>
              <th>تاریخ ارسال</th>
              <th>پاسخ</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_SMS">
              <td>{{DataList_SMS.indexOf(item)+1}}</td>
              <td>{{item.title}}</td>
              <td>{{item.dsc}}</td>
              <td>{{item.persianDate}}</td>
              <td>{{item.response}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <pagination-controls id="DataList_SMSTable" nextLabel="بعدی" previousLabel="قبلی"
      (pageChange)="page = $event"></pagination-controls>
  </div>
</div>
